import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

// Auth
export const login = (username, password) =>
  api.post("/auth/login", { username, password });

export const getMe = () => api.get("/auth/me");

export const changePassword = (currentPassword, newPassword) =>
  api.post(`/auth/change-password?current_password=${encodeURIComponent(currentPassword)}&new_password=${encodeURIComponent(newPassword)}`);

// Settings
export const getSettings = () => api.get("/settings");
export const updateSettings = (data) => api.put("/settings", data);

// Forms
export const getForms = (params = {}) => api.get("/forms", { params });
export const getForm = (id) => api.get(`/forms/${id}`);
export const createForm = (data) => api.post("/forms", data);
export const updateForm = (id, data) => api.put(`/forms/${id}`, data);
export const deleteForm = (id) => api.delete(`/forms/${id}`);

// PDF
export const getFormPdfUrl = (id) => {
  const token = localStorage.getItem("token");
  return `${API_BASE}/forms/${id}/pdf?token=${token}`;
};

export const getFormPdfPreview = (id) => api.get(`/forms/${id}/pdf-preview`);

// Email
export const sendFormEmail = (id, recipientEmail, subject) =>
  api.post(`/forms/${id}/send`, { recipient_email: recipientEmail, subject });

// Inventory Export
export const exportInventoryXlsx = () =>
  api.get("/inventory/export", { responseType: "blob" });

// Public API-Key management
export const regenerateApiKey = () => api.post("/settings/api-key/regenerate");
export const revokeApiKey = () => api.delete("/settings/api-key");
export const downloadApiDocs = (lang, baseUrl) =>
  api.get("/settings/api-docs", {
    params: { lang, base_url: baseUrl },
    responseType: "blob",
  });

export default api;
